import React, { Fragment } from "react";
import { ArrowRight, Database, Redo2, Undo2 } from "lucide-react";
import {
  Card,
  Connector,
  HistoryActions,
  HistoryButton,
  Icon,
  Label,
  Metadata,
  MetadataSeparator,
  StageCopy,
  Stages,
  Strip,
  Title,
} from "./DataStudioPipelineStrip.styles";
import type { DataStudioPipelineStripProps } from "./DataStudioPipelineStrip.types";

export const DataStudioPipelineStrip: React.FC<
  DataStudioPipelineStripProps
> = ({ pipeline, onStageSelect, onUndo, onRedo }) => (
  <Strip aria-labelledby="data-studio-pipeline-label">
    <Label id="data-studio-pipeline-label">Pipeline</Label>

    <Stages aria-label="Pipeline stages">
      {pipeline.stages.map((stage, index) => {
        const selected = stage.id === pipeline.activeStageId;

        return (
          <Fragment key={stage.id}>
            {index > 0 ? (
              <Connector aria-hidden="true">
                <ArrowRight />
              </Connector>
            ) : null}
            <Card
              type="button"
              $selected={selected}
              disabled={!onStageSelect}
              onClick={() => onStageSelect?.(stage.id)}
              aria-label={`${stage.title}, ${stage.rowCount.toLocaleString()} rows, ${stage.columnCount} columns`}
              aria-pressed={selected}
              data-stage-kind={stage.kind}
            >
              <Icon $selected={selected} aria-hidden="true">
                <Database />
              </Icon>
              <StageCopy>
                <Title>{stage.title}</Title>
                <Metadata>
                  <span>{stage.rowCount.toLocaleString()} rows</span>
                  <MetadataSeparator />
                  <span>{stage.columnCount} columns</span>
                </Metadata>
              </StageCopy>
            </Card>
          </Fragment>
        );
      })}
    </Stages>
    <HistoryActions>
      <HistoryButton
        type="button"
        aria-label="Undo pipeline change"
        disabled={!pipeline.canUndo || !onUndo}
        onClick={onUndo}
      >
        <Undo2 aria-hidden="true" />
      </HistoryButton>
      <HistoryButton
        type="button"
        aria-label="Redo pipeline change"
        disabled={!pipeline.canRedo || !onRedo}
        onClick={onRedo}
      >
        <Redo2 aria-hidden="true" />
      </HistoryButton>
    </HistoryActions>
  </Strip>
);

export default DataStudioPipelineStrip;
